import _ from 'lodash';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './LongIdentifierTextField.scss';
import classNames from 'classnames';
import creditCardType from 'credit-card-type';

export default class LongIdentifierTextField extends Component {
    static propTypes = {
        value: PropTypes.string,
        placeholder: PropTypes.string,
        characterGroupLength: PropTypes.number,
        maxCharacterGroups: PropTypes.number,
        className: PropTypes.string,
        errorClassName: PropTypes.string,
        error: PropTypes.string,
        disabled: PropTypes.bool,
        onChange: PropTypes.func
    };

    static defaultProps = {
        characterGroupLength: 4,
        maxCharacterGroups: 5
    };

    render() {
        const {
            value,
            placeholder,
            characterGroupLength,
            maxCharacterGroups,
            className,
            errorClassName,
            error,
            disabled
        } = this.props;

        const inputClassName = classNames(styles.field, className, {
            [styles.highlightError]: error,
            [errorClassName]: error
        });

        const formattedValue = this.groupDigitWithSpaces(value);

        const maxLength = maxCharacterGroups * characterGroupLength + (maxCharacterGroups - 1);

        return (
            <input type='text'
                   className={inputClassName}
                   placeholder={placeholder}
                   value={formattedValue}
                   disabled={disabled}
                   maxLength={maxLength}
                   onChange={this.handleChange}/>
        );
    }

    groupDigitWithSpaces(text = '') {
        const possibleTypes = creditCardType(text);
        const withoutSpace = this.removeSpaces(text);
        if (possibleTypes.length === 0)
            return withoutSpace;

        const cardType = possibleTypes[0];

        const {gaps} = cardType;
        const parts = gaps.map((gapIndex, index) => {
            const prevGap = gaps[index - 1] ? gaps[index - 1] : 0;
            return withoutSpace.substring(prevGap, gapIndex);
        }).filter(Boolean);

        //add last part
        const lastGap = gaps[gaps.length - 1];
        const lastPart = withoutSpace.substring(lastGap, withoutSpace.length);
        if (lastPart && lastGap < withoutSpace.length)
            parts.push(lastPart);

        return parts.join(' ');
    }

    removeSpaces(text) {
        return text.replace(/\s/g, '');
    }

    handleChange = ({target}) => {
        const {value, selectionStart, selectionEnd} = target;

        this.props.onChange({
            target: {
                value: this.removeSpaces(value)
            }
        });

        setTimeout(() => {
            const textBeforeSelection = value.slice(0, selectionStart);
            const alignGain = Math.max(0, Math.abs(this.groupDigitWithSpaces(textBeforeSelection).length - textBeforeSelection.length));
            target.selectionStart = selectionStart + alignGain;
            target.selectionEnd = selectionEnd + alignGain;
        });
    };
}



// WEBPACK FOOTER //
// ./src/components/controls/LongIdentifierTextField.jsx